(function (root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD
    define(['torso/modules/Collection', 'torso/modules/Model', 'services/documentExtService'], factory);
  } else if (typeof exports === 'object') {
    // Node, CommonJS-like
    var TorsoCollection = require('backbone-torso/modules/Collection');
    var TorsoModel = require('backbone-torso/modules/Model');
    var documentExtService = require('./../urls').documentExtService;
    module.exports = factory(TorsoCollection, TorsoModel, documentExtService);
  } else {
    throw 'Only AMD and CommonJS imports are supported.';
  }
}(this, function (TorsoCollection, TorsoModel, documentExtService) {
  'use strict';

  /**
   * Receives documents from the DocumentExtService which serves the DocumentInfoDTO resource
   * @class DocumentCollection
   * @constructor
   */
  return new (TorsoCollection.extend({
    model: TorsoModel,
    url: documentExtService,
    fetchHttpAction: 'POST',

    /**
     * Compare visit time first, then file name.
     * Returns -1 if modelA should come before modelB, 0 if equal, or 1 if modelA should come after modelB
     * @method comparator
     * @override
     * @param modelA {Object} one model
     * @param modelB {Object} the other model
     */
    comparator: function(modelA, modelB) {
      var comparatorValue = this.compareDates(modelA.get('visitDate'), modelB.get('visitDate'));
      //if dates were equal, compare by file name instead
      if(comparatorValue === 0) {
        comparatorValue = modelA.get('fileName').localeCompare(modelB.get('fileName'));
      }
      return comparatorValue;
    },

    /**
     * Helper function to compare document dates.
     * @method compareDates
     * @param dateA {Integer}
     * @param dateB {Integer}
     */
    compareDates: function(dateA, dateB) {
      var comparatorValue;
      if(dateA === dateB) {
        comparatorValue = 0;
      } else if (dateA < dateB) {
        comparatorValue = -1;
      } else {
        comparatorValue = 1;
      }
      return comparatorValue;
    }
  }))();
}));
